import dayjs from 'dayjs';
import 'dayjs/locale/es';

const formatDateFilter = ( stringDate: string, format: string) => {
  let result = '';
  const dayjsInstance = dayjs( stringDate, { locale: 'es' } );
  if ( dayjsInstance.isValid() ) {
    result = dayjsInstance.format( format );
  }
  return result;
};

export default formatDateFilter;
